import logo from "../../Images/logo.png";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <div
      id="footer"
      className="w-full min-h-[60vh] flex items-center justify-center bg-black   "
    >
      <div className="md:w-2/3 w-full px-4 text-white flex flex-col ">
        <div className="w-full text-4xl font-bold mt-9">
          <h1 className="w-full md:w-2/3 ">
            How can we help you. get in touch
          </h1>
        </div>
        <div className="flex mt-8 flex-col md:flex-row md:justify-between">
          <p className="w-full md:w-2/3 text-gray-400">
            To ensure that all Wikipedia content is verifiable, anyone may
            question an uncited claim. If your work has been tagged
          </p>
          <div className="w-44 pt-6 md:pt-0">
            <Link className="bg-Brand-Color hover:bg-Brand-Color-Light font-bold cursor-pointer justify-center text-center rounded-lg shadow px-10 py-3 flex items-center">
              Contact US
            </Link>
          </div>
        </div>
        <div className="flex flex-col">
          {/* Company Logo-Name */}
          <div className="flex mt-24  flex-row flex-wrap justify-between space-x-3">
            <div className="order-1  h-1/2 sm:mb-3 ">
              <div className=" flex items-center">
                <img
                  className="mx-auto h-10 me-2 w-auto rounded-lg shadow-lg"
                  src={logo}
                  alt="Your Company"
                  loading="lazy"
                />
                <h3 className="text-Brand-Color font-extrabold text-2xl underline  cursor-pointer">
                  jsonOnClouds
                </h3>
              </div>
            </div>
            {/* Links */}
            <div className=" order-3 sm:order-2 mt-3  sm:mt-0">
              <div className=" flex space-x-5 overflow-hidden">
                <Link
                  to="/about"
                  className=" md:block cursor-pointer text-gray-600 hover:text-Brand-Color-Light  hover:underline uppercase"
                >
                  About
                </Link>
                <Link className=" md:block cursor-pointer text-gray-600 hover:text-Brand-Color-Light  hover:underline uppercase">
                  Services
                </Link>
                <Link className=" md:block cursor-pointer text-gray-600 hover:text-Brand-Color-Light  hover:underline uppercase">
                  Why us
                </Link>
                <Link className=" md:block cursor-pointer text-gray-600 hover:text-Brand-Color-Light  hover:underline uppercase">
                  Contact
                </Link>
              </div>
            </div>
            {/* Social */}
            <div className="order-2 sm:order-3 mt-3 sm:mt-0">
              <div className="flex flex-row space-x-8 items-center justify-between">
                <Link
                  to="#"
                  className="rounded-md bg-[#ffa20015] py-1 px-2 ring-1 ring-[#ffa200a8]  cursor-pointer flex justify-center items-center hover:bg-[#ffa20031] focus:bg-[#ffa20031 transition duration-200 delay-150 hover:delay-200"
                >
                  <i className="ri-github-line text-white text-lg font-extrabold"></i>
                </Link>
                <Link
                  to="#"
                  className="rounded-md bg-[#ffa20015] py-1 px-2 ring-1 ring-[#ffa200a8]  cursor-pointer flex justify-center items-center hover:bg-[#ffa20031] focus:bg-[#ffa20031 transition duration-200 delay-150 hover:delay-200"
                >
                  <i className="ri-linkedin-line text-white text-lg font-extrabold"></i>
                </Link>
                <Link
                  to="#"
                  className="rounded-md bg-[#ffa20015] py-1 px-2 ring-1 ring-[#ffa200a8]  cursor-pointer flex justify-center items-center hover:bg-[#ffa20031] focus:bg-[#ffa20031 transition duration-200 delay-150 hover:delay-200"
                >
                  <i className="ri-mail-line text-white text-lg font-extrabold"></i>
                </Link>
              </div>
            </div>
          </div>
          <hr className="border-gray-600 mt-2" />
          <p className="w-full text-center  text-gray-600 my-6">
            Copyright © 2023 jsonOnClouds
          </p>
        </div>
      </div>
    </div>
  );
}
